import { render, staticRenderFns } from "./EmployeeVisa.vue?vue&type=template&id=392ff71e&"
import script from "./EmployeeVisa.vue?vue&type=script&lang=js&"
export * from "./EmployeeVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports